import { createDecorator, } from 'vue-class-component';
export function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        createDecorator(function (componentOptions, propName) {
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
        })(target, key);
    };
}
